import { render, staticRenderFns } from "./listadoEmpresas.vue?vue&type=template&id=51dcf7f5&"
import script from "./listadoEmpresas.vue?vue&type=script&lang=js&"
export * from "./listadoEmpresas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports